export default {
  init() {
    let img = $('#home-slider-image').attr('src');
    if (img) {
      $('#home-slider').css('background-image', 'url("'+img+'")');
    }
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/rewards.js